<div class="flex flex-col gap-4" #soccerMatchesContainer>
  @if(teamMatchesActive()!== null && teamMatchesActive()!.length > 0){

  <div class="font-roboto-500 text-18 max-sm:text-14 mt-3 mb-2">
    {{ "MatchesToday" | translate }}
  </div>

  @for (competitionByDate of teamMatchesActive(); track $index) {
  <!--  -->
  @if(isNextMatches(competitionByDate.date) ) {
  <app-date-label [matchDate]="competitionByDate.date" />
  }
  <!--  -->

  @for (competition of competitionByDate.competitions; track $index) {

  <app-competition-by-team-row [data]="competition" entity="Competition" />
  } } } @else {

  <!--  -->
  @if(!fetchComputed().isLoading){

  <app-no-result message="NotAvalaibleInformation" />
  } }
</div>

<div #scrollTrigger style="height: 1px"></div>

<!-- Case Loading -->
@if(fetchComputed().isLoading){
<app-skeleton-matches-list />
}

<!-- Case Error -->
@if((fetchComputed().isError && !fetchComputed().isLoading) ){
<app-no-result message="NotAvalaibleInformation" />
}
